import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page" >
      {/* Hero Section */}
      <div className="about-hero">
        <div className="hero-background"></div>
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-text">✨ Premium Experience</span>
          </div>
          <h1 className="hero-title">About Sangam Resort & Banquet</h1>
          <p className="hero-subtitle">Experience hospitality with nature at its heart.</p>
        </div>
      </div>

      {/* About Introduction Section */}
      <section className="about-intro">
        <div className="intro-container">
          <div className="about-img">
            <div className="image-wrapper">
              <img src="/resort.jpg" alt="Sangam Resort" />
              <div className="image-overlay"></div>
            </div>
          </div>
          <div className="about-content">
            <div className="content-header">
              <span className="section-label">Our Story</span>
              <h2 className="section-title">Who We Are</h2>
            </div>
            <p className="content-text">
            Welcome to Sangam Resort & Banquet – your perfect escape where nature and comfort come together. Surrounded by lush greenery and packed with top-notch amenities, our resort is ideal for families, couples, and corporate groups.
            </p>
            <p className="content-text">
            Whether you're planning a relaxing weekend, a dreamy wedding, or a fun day out, we’ve got the space, vibe, and service to make it truly special.
            </p>
            <div className="content-features">
              <div className="feature-item">
                <span className="feature-icon">🌿</span>
                <span className="feature-text">Nature-Centric</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🏆</span>
                <span className="feature-text">Premium Service</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">💝</span>
                <span className="feature-text">Memorable Experiences</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-mission">
        <div className="mission-container">
          <div className="mission-header">
            <span className="section-label">Our Purpose</span>
            <h2 className="section-title">Our Mission</h2>
          </div>
          <div className="mission-content">
            <p className="mission-text">
              To provide a nature-centric escape where people can rejuvenate, celebrate, and create lifelong memories with loved ones.
            </p>
          </div>
          <div className="mission-stats">
            <div className="stat-item">
              <span className="stat-number">1+</span>
              <span className="stat-label">Years of Excellence</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">5000+</span>
              <span className="stat-label">Happy Guests</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100+</span>
              <span className="stat-label">Events Hosted</span>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values">
        <div className="values-container">
          <div className="values-header">
            <span className="section-label">What We Believe</span>
            <h2 className="section-title">Our Values</h2>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🌱</div>
              <h3 className="value-title">Sustainability</h3>
              <p className="value-description">
                We're committed to preserving the natural beauty that surrounds us while providing exceptional hospitality.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3 className="value-title">Hospitality</h3>
              <p className="value-description">
                Every guest is treated like family, with personalized service that exceeds expectations.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">✨</div>
              <h3 className="value-title">Excellence</h3>
              <p className="value-description">
                We continuously strive to deliver the highest quality experiences in every aspect of our service.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;